import { getGlobalDateTimeFilter } from "services";

export const discountReportFilterState = (venueId) => {
  const dateTime = getGlobalDateTimeFilter();
  return {
    venueId,
    page: 1,
    pageSize: 20,
    searchKey: "",
    dateRange: [dateTime[0], dateTime[1]],
    locations: [],
    discount: null,
    sort: { key: "sales", value: "desc" },
  };
};
